var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container",class:{
    active: _vm.currentActiveTab === _vm.index,
  },on:{"click":function($event){return _vm.$emit('changeView', { index: _vm.index, className: _setup.classes.container })}}},[(_setup.url)?_c('i',{staticClass:"container__icon",class:{
      active: _vm.currentActiveTab === _vm.index,
    },style:(_setup.styles),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.title)?_c('p',{staticClass:"container__title",class:{
      active: _vm.currentActiveTab === _vm.index,
    }},[_vm._v("\n    "+_vm._s(_vm.title.trim())+"\n  ")]):_vm._e(),_vm._v(" "),_c(_setup.AzIcon,{staticClass:"container__arrow",attrs:{"icon-name":"chevron-down","size":"smaller","aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }